export default class Templates {
	static getCategoryItemTemplate(config) {
		const { title, iconSrc, gradientFrom, gradientTo } = config;
		return (`
			<div class="result-categories_item result-category">
				<div class="result-category_chart result-category-chart" style="background:linear-gradient(225deg,${gradientFrom} 0%,${gradientTo} 100%);">
					<svg viewBox="0 0 64 64" width="88" height="87" class="result-category-chart_pie svg-pie" style="border-radius:50%;">
						<circle class="svg-pie_chart" r="50%" cx="50%" cy="50%" style="stroke-dasharray:0 300;stroke-width:6;transform-origin:center;transform:rotateZ(-90deg);" stroke="#4ED401" fill="transparent"></circle>
					</svg>

					<img class="result-category-chart_icon" width="64" height="64" src="${iconSrc}" alt="${title}" />
				</div>

				<span class="result-category_name">${title}</span>
			</div>
		`);
	}

	static getCourseBarTemplate(config) {
		const { href, title, type, isOnline, iconSrc, gradientFrom, gradientTo } = config;
		const onlineTypeTemplate = `<span class="course-bar_type -online">Online</span>`;

		return (`
			<li class="result-courses_item">
				<a class="course-bar -large${isOnline ? '' : ' -icon-square'}" href="${href}">
					<span class="course-bar_bg" style="background:linear-gradient(225deg,${gradientFrom} 0%,${gradientTo} 100%);"></span>
	
					<div class="course-bar_body">
						<span class="course-bar_label">${title}</span>
						
						<div class="course-bar_group">
							<span class="course-bar_type">${type}</span>
							${isOnline ? onlineTypeTemplate : ''}
						</div>
					</div>
					
					<div class="course-bar_icon" style="background:linear-gradient(225deg,${gradientFrom} 0%,${gradientTo} 100%);">
						<img class="course-bar_svg" width="48" height="48" src="${iconSrc}" alt="${title}" />
					</div>
				</a>
			</li>
		`);
	}

	static getSprintBarTemplate(config) {
		const { href, title, iconSrc } = config;

		return (`
			<li class="result-courses_item">
				<div class="sprint-link -proftest">
					<a href="${href}" class="block-anchor">${title}</a>

					<div class="sprint-link-wrapper">
						<p class="sprint-link-title">${title}</p>
						<p class="sprint-link-subtitle sprint-link-wrapper_subtitle">Безкоштовний спринт</p>
					</div>
				
					<img data-src="${iconSrc}"
						 alt="${title}"
						 class="sprint-link-icon lozad"
					>
				</div>
			</li>
		`);
	}

	static getResultItemTemplate(config) {
		let { title, value } = config;
		value = Math.round(value);
		const chartValue = value == 0 ? 0 : value * 2 + 1;
		return (`
			<li class="result-details_item result-item">
				<p class="result-item_chart result-chart">
					<svg viewBox="0 0 64 64" width="48" height="48" class="result-chart_pie svg-pie" style="border-radius:50%;">
						<circle class="svg-pie_chart" r="50%" cx="50%" cy="50%" style="stroke-dasharray:${chartValue} 300;stroke-width:10;transform-origin:center;transform:rotateZ(-90deg);" stroke="#4ED401" fill="transparent"></circle>
					</svg>
					<span class="result-chart_text">${value}%</span>
				</p>
				<span class="result-item_text">${title}</span>
			</li>
		`);
	}
}